// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1e1j2","large":"styles_large__2gKA6"};